import React from 'react';
import CountdownBanner from 'components/revelo-ui/content/countdown-banner';

const CountdownBannerTastic = ({ data }) => {
  return <CountdownBanner {...data} />;
};

export default CountdownBannerTastic;
